import { supabase } from '@/lib/supabase/client'

export function useSupabase() {
  // Usa a instância singleton ao invés de criar uma nova
  return { supabase }
} 